import "./pagination-table.scss";
import React from "react";
import DataTable, { createTheme } from "react-data-table-component";
import Pill from "../../Components/Pill/pill";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSquarePlus } from "@fortawesome/free-solid-svg-icons";

function PaginationTable(props) {
  const customStyles = {
    table: {
      oveflow: "inherit",
    },
    rows: {
      style: {
        alignItems: "center",
        alignContent: "center",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(91, 90, 255, 0.2)",
        color: "#070721",
        borderBottomColor: "#E8E8E9",
        outlineColor: "#E8E8E9",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        color: "#000",
        fontSize: 12,
        height: 40,
        minHeight: 40,
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        minHeight: 40,
        height: "auto",
      },
    },
  };

  const gridStyle = {
    ...customStyles,
    ...props.customStyle,
  };

  createTheme(
    "solarized",
    {
      text: {
        primary: "#7D8298",
        secondary: "#7D8298",
      },
      background: {
        default: "#F6F7FB",
      },
      context: {
        background: "#f0f",
        text: "#7D8298",
      },
      divider: {
        default: "#fff",
      },
      striped: {
        default: "#fff",
        text: "#7D8298",
      },
      selected: {
        default: "rgba(0, 0, 0, .7)",
        text: "blue",
      },
      highlightOnHover: {
        default: "#f00",
      },
      action: {
        button: 'rgba(0,0,0,.54)',
        hover: 'rgba(0,0,0,.08)',
        disabled: 'rgba(0,0,0,.12)',
      },
    },
    "light"
  );

  const {
    columns,
    data,
    gridLoading,
    perPage,
    page,
    total,
    setPerPage,
    setPage,
    topHeaderMessage,
    header = ``,
    pills,
    onClickPills,
    filter,
    onSort,
    defaultSortFieldId,
    defaultSortAsc = true,
    conditionalRowStyles,
    searchItem,
    onChangeSearch,
    placeholder = ``,
    serverPagination = true,
    displayRowPerPage = true,
    customAddItemText,
    iconRightHeaderClass,
    iconRightHeader,
    onClickAddItem,
    className,
    showHeader = true,
    sort
  } = props;

  const headerMessage = topHeaderMessage ? (
    <div className="headerMessage">{topHeaderMessage}</div>
  ) : null;

  const noRecordsFound = (
    <div className="noRecordsFound">No records found.</div>
  );

  const pillsContent = pills ? (
    <div className="pills">
      {pills.map(({ name, key }) => {
        return (
          <Pill
            title={name}
            key={key}
            onClick={onClickPills ? onClickPills(key) : () => {}}
            className={filter === key ? `active` : ``}
          />
        );
      })}
    </div>
  ) : null;

  const searchBar = onChangeSearch ? (
    <span className="serch-box-icon">
      <FontAwesomeIcon className="col magnifying-glass" icon={faSearch} />
      <input
        type="text"
        className="search-box"
        placeholder={placeholder}
        value={searchItem}
        onChange={onChangeSearch}
      />
    </span>
  ) : null;

  // const conditionalRowStyles = [
  //   {
  //     when: row => row.available,
  //     style: {
  //       backgroundColor: 'green',
  //       color: 'white',
  //       '&:hover': {
  //         cursor: 'pointer',
  //       },
  //     },
  //   },
  //   // You can also pass a callback to style for additional customization
  //   {
  //     when: row => !row.available,
  //     style: row => ({ backgroundColor:  'pink'}),
  //   },
  // ];

  const rightHeader = onClickAddItem ? (
    <div className="col header reverse">
      <span className="right-header" onClick={onClickAddItem}>
        <FontAwesomeIcon
          className={`add-icon ${iconRightHeaderClass}`}
          icon={iconRightHeader || faSquarePlus}
        />
        <span className="post-add-icon">{customAddItemText || "Add Item"}</span>
      </span>
    </div>
  ) : null;

  return (
    <div className={`pagination-table ${className}`}>
      {headerMessage}
      {showHeader && <div className="header-container">
        <div className="col header">{header}</div>
        {rightHeader}
      </div>}
      {pillsContent}
      {searchBar}
      <DataTable
        className={`over-menu ${className}`}
        defaultSortFieldId={defaultSortFieldId}
        defaultSortAsc={defaultSortAsc}
        theme="solarized"
        columns={columns}
        data={data}
        highlightOnHover={true}
        persistTableHead={true}
        pointerOnHover={true}
        striped={true}
        progressPending={gridLoading}
        paginationPerPage={perPage}
        paginationDefaultPage={page}
        pagination={true}
        paginationComponentOptions={{ noRowsPerPage: !displayRowPerPage }}
        paginationServer={serverPagination}
        paginationTotalRows={total}
        onChangeRowsPerPage={setPerPage}
        onChangePage={setPage}
        customStyles={gridStyle}
        noDataComponent={noRecordsFound}
        onSort={onSort}
        conditionalRowStyles={conditionalRowStyles}
        sort={sort}
      />
    </div>
  );
}
export default PaginationTable;
